import { useAccessibilityModeEnabled } from '@frontend/accessibility';
import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { theme } from '@frontend/theme';
import { TextLink, Icon, Dot, ContentLoader, NakedUl } from '@frontend/design-system';
import { Section } from '../../../layout/section';

export const LinkSection = ({ closeModal, isLoading }: { closeModal: () => void; isLoading: boolean }) => {
  const { t } = useTranslation();
  const { navigate: settingsNavigate } = useSettingsNavigate();
  const { isEnabled: accessibilityModeEnabled } = useAccessibilityModeEnabled('isEnabled');
  const links = [
    {
      label: t('Manage My Support Cases'),
      href: 'https://weavehelp.com/weavehelp/login?startURL=/weavehelp/case/Case/Default',
      target: 'blank',
      rel: 'noopener noreferrer',
      isExternal: true,
    },
    {
      label: t('Refer Weave'),
      href: 'https://www.getweave.com/refer',
      target: 'blank',
      rel: 'noopener noreferrer',
      isExternal: true,
    },
    {
      label: t('Weave Training Camp'),
      href: 'https://trainingcamp.weavehelp.com/',
      target: 'blank',
      rel: 'noopener noreferrer',
      isExternal: true,
    },
    {
      label: t('Accessibility Preferences'),
      hasDot: accessibilityModeEnabled,
      onClick: () => {
        settingsNavigate({ to: '/personal/preferences/accessibility' });
        closeModal();
      },
    },
    {
      label: t('Privacy Policy'),
      href: 'https://www.getweave.com/legal/privacy/',
      target: 'blank',
      rel: 'noopener noreferrer',
      isExternal: true,
    },
    {
      label: t('Personal Preferences'),
      onClick: () => {
        settingsNavigate({ to: '/personal' });
        closeModal();
      },
    },
    {
      label: t('Feedback'),
      href: 'mailto:product-feedback@getweave.com',
      target: 'blank',
      rel: 'noopener noreferrer',
      isExternal: true,
    },
  ];
  return (
    <Section css={{ alignSelf: 'end' }}>
      <ContentLoader message={t('Signing out')} show={isLoading} />
      <NakedUl css={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}>
        {links.map(({ label, onClick, href, isExternal, hasDot, ...rest }) => (
          <li
            key={`link-key-${label}`}
            css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}
            data-trackingid={`user-profile-${label}-link`}
          >
            <TextLink
              href={href}
              onClick={!href ? onClick : undefined}
              css={{ display: 'flex', gap: theme.spacing(1), alignItems: 'center' }}
              {...rest}
            >
              {label} {isExternal && <Icon name='external-link' size={12} />}
            </TextLink>
            {hasDot && <Dot color='critical' css={{ position: 'relative' }} />}
          </li>
        ))}
      </NakedUl>
    </Section>
  );
};
